import { Chip } from "@mui/material";

const getChipStyles = (backgroundColor, color, borderColor) => {
  return {
    backgroundColor,
    color,
    borderColor,
  };
};

const getChipProps = (params) => {
  switch (params.value) {
    case "On Hold":
      return {
        label: "On Hold",
        sx: getChipStyles("#fff3e0", "#e65100", "#ffe0b2"), // orange tones
      };
    case "In Progress":
      return {
        label: "In Progress",
        sx: getChipStyles("#e3f2fd", "#2196f3", "#bbdefb"),
      };
    case "Completed":
      return {
        label: "Completed",
        sx: getChipStyles("#e8f5e9", "#4caf50", "#c8e6c9"),
      };
    case "In Queue":
      return {
        label: "In Queue",
        sx: getChipStyles("#f5f5f5", "#757575", "#e0e0e0"),
      };
    case "Canceled":
      return {
        label: "Canceled",
        sx: getChipStyles("#ffebee", "#d32f2f", "#ffcdd2"), 
      };

    case "GIT":
      return {
        label: "GIT",
        sx: getChipStyles("transparent", "#0097a7", "#c8e6c9"),
      };

    case "Delay Picking":
      return {
        label: "Delay Picking",
        sx: getChipStyles("transparent", "#5139d4", "#BEDDFC"),
      };

    default:
      return { label: params.value };
  }
};

export const getColumns = (
  hasReason,
  shouldHideStatus,
  isDelayPicking,
  isFakeCustomerOrder,
  type
) => [
  {
    field: "job_id",
    headerName: "SSS Job No",
    width: 120,
  },
  { field: "custOrder", headerName: "Cust Order", width: 120 },
  {
    field: "customer",
    headerName: "Customer",
    width: 120,
  },
  { field: "orderDate", headerName: "Order Date", width: 170 },
  ...(isDelayPicking
    ? [
        {
          field: "delivery_date",
          headerName: "Delivery Date",
          width: 120,
          align: "center",
        },
      ]
    : []),
  {
    field: "total_order_lines",
    headerName: "Order Line",
    width: 100,
    align: "center",
  },
  ...(type !== "in-queue"
    ? [
        {
          field: "pickup_qty",
          headerName: "Pick Up Qty",
          width: 100,
          align: "center",
          sortable: false,
        },
      ]
    : [
        {
          field: "bay",
          headerName: "Bay",
          width: 100,
        },
      ]),
  {
    field: "cutoff_date_time",
    headerName: "Cutoff Time",
    width: 165,
    sortable: false,
  },
  ...(type !== "git"
    ? [
        {
          field: "picker",
          headerName: "Picker",
          width: 130,
        },
      ]
    : []),
    ...(type === "git"
    ? [
        {
          field: "erp_order_status", 
          headerName: "SSS ERP Status",
          width: 145,
        
          
        },
      ]
    : []),
  {
    field: "git_reference",
    headerName: "GIT REFERENCE",
    width: 140,
  },
  ...(!shouldHideStatus
    ? [
        {
          field: "status",
          headerName: "Status",
          width: 110,
          renderCell: (params) => {
            const chipProps = getChipProps(params);
            return params.value ? (
              <Chip size="small" variant="outlined" {...chipProps} />
            ) : (
              ""
            );
          },
        },
      ]
    : []),
  ...(!isFakeCustomerOrder
    ? [
        {
          field: "order_tag",
          headerName: "Order Tag",
          headerAlign: "center",
          align: "center",
          width: 150,
          renderCell: (params) => {
            const chipProps = getChipProps(params);
            return params.value ? (
              <Chip size="small" variant="outlined" {...chipProps} />
            ) : (
              ""
            );
          },
        },
      ]
    : []),

  ...(hasReason
    ? [
        {
          field: "order_hold_reason",
          headerName: "Reason",
          width: 140,
          sortable: false,
        },
      ]
    : []),
];
